import DataTablePageSize from './DataTablePageSize';

interface Props {
  headerButton?: JSX.Element;
  documentDropdown?: JSX.Element;
  searchComponent?: JSX.Element;
  pageSizeOptions: number[];
  onPageSizeChange: (size: number) => void;
}

const DataTableHeader: React.FC<Props> = ({
  headerButton,
  documentDropdown,
  searchComponent,
  pageSizeOptions,
  onPageSizeChange,
}) => (
  <>
    {(headerButton || documentDropdown) && (
      <div className="flex flex-wrap justify-between gap-4 border-b border-stroke px-4 pb-4 dark:border-strokedark md:px-8">
        {headerButton && <div>{headerButton}</div>}
        {documentDropdown && <div>{documentDropdown}</div>}
      </div>
    )}

    <div className="flex flex-wrap justify-between gap-4 border-b border-stroke px-4 pb-4 pt-4 dark:border-strokedark md:px-8">
      <div className="w-full md:w-1/3">{searchComponent}</div>
      <DataTablePageSize
        pageSizeOptions={pageSizeOptions}
        onPageSizeChange={onPageSizeChange}
      />
    </div>
  </>
);

export default DataTableHeader;
